<footer class="main-footer">
  <div class="pull-right hidden-xs">
    <a href="mailto:suporte@meurhonline.com.br"><b>suporte@meurhonline.com.br</b></a>
  </div>
  <strong>Copyright © {{anoAtual}} <a>Meu RH Online</a> - </strong>Todos os direitos reservados.
</footer>